import { faInfo, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect } from "react";

const RocketRangeUserGuide: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const hasSeenGuide = localStorage.getItem("hasSeenUserGuide");
        if (!hasSeenGuide) {
            setIsOpen(true);
            localStorage.setItem("hasSeenUserGuide", "true");
        }
    }, []);

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleShowGuide = () => {
        setIsOpen(true);
    };

    return (
        <>
            {/* Info Button */}
            <button
                onClick={handleShowGuide}
                className="py-2"
            >
                <FontAwesomeIcon className="text-gray-400 text-3xl" icon={faInfoCircle}/>
            </button>

            {/* Modal Dialog */}
            {isOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-gray-900 text-white rounded-lg shadow-lg p-6 w-[90%] sm:w-[600px] relative">
                        <button
                            onClick={handleClose}
                            className="absolute top-2 right-2 text-gray-400 hover:text-gray-200"
                        >
                            ✕
                        </button>
                        {/* Scrollable Content */}
                        <div className="max-h-[70vh] overflow-y-auto pr-4">
                            <h2 className="text-2xl font-bold mb-4">Rocket Range: User Guide</h2>
                            <p className="mb-4">
                                Predict the daily price movement of ALPH and win rewards in this crypto game. Powered by DIA Oracle price updates,
                                Rocket Range ensures fair and accurate pricing.
                            </p>

                            <h3 className="text-lg font-bold mt-4">How to Play</h3>
                            <ol className="list-decimal list-inside mb-4">
                                <li>
                                    <strong>Place Your Bet:</strong> Choose from five prediction ranges:
                                    <ul className="list-disc list-inside pl-4">
                                        <li>UP 4% or more</li>
                                        <li>UP 1-4%</li>
                                        <li>NO Change (-1% to 1%)</li>
                                        <li>DOWN 1-4%</li>
                                        <li>DOWN 4% or more</li>
                                    </ul>
                                    Enter your ALPH bet amount and confirm, <strong>keep in mind all bets are final</strong>.
                                </li>
                                <li>
                                    <strong>Wait for the Round to End:</strong> Each round lasts 24 hours. The token's starting and ending prices are determined by DIA Oracle.
                                </li>
                                <li>
                                    <strong>Win Rewards:</strong> If your prediction is correct, you’ll share the prize pool for that range based on your stake.
                                </li>
                            </ol>

                            <h3 className="text-lg font-bold mt-4">Example</h3>
                            <p className="mb-4">
                                <strong>Start Price:</strong> $1.50 | <strong>End Price:</strong> $1.575
                                <br />
                                <strong>Price Movement:</strong> UP 5% → <strong>Winning Range:</strong> UP 4%+
                            </p>

                            <h3 className="text-lg font-bold mt-4">Important Notes</h3>
                            <ul className="list-disc list-inside mb-4">
                                <li>
                                    <strong>Beta Software:</strong> Rocket Range is a beta platform. Bugs or issues may occur. No warranties or guarantees are provided.
                                </li>
                                <li>
                                    <strong>Financial Risk:</strong> Play with only with what you can afford to lose.
                                </li>
                            </ul>

                            <h3 className="text-lg font-bold mt-4">Enjoy the Game!</h3>
                            <p>
                                Test your market intuition and aim for the stars. Good luck! 🚀
                            </p>
                        </div>
                        {/* Fixed Button */}
                        <div className="mt-6">
                            <button
                                onClick={handleClose}
                                className="px-6 py-3 bg-red-600 text-white rounded-md hover:bg-red-700 transition w-full"
                            >
                                Got It!
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default RocketRangeUserGuide;
